<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <form
                    action=""
                    @submit.prevent="search"
                    class="search-form"
                >
                    <div class="row">
                        <div class="col">
                            <input
                                type="search"
                                placeholder="Search..."
                                v-model="keyword"
                                class="form-control"
                            >
                        </div>
                        <div class="col">
                            <site-search @change="siteChanged" />
                        </div>
                        <div
                            class="col"
                            style="flex: 0 0 7rem"
                        >
                            <input
                                type="search"
                                placeholder="Code"
                                v-model="code"
                                class="form-control"
                                size="5"
                            >
                        </div>
                        <div class="col btn-col">
                            <button class="btn btn-primary">
                                Search
                            </button>
                            <button
                                class="btn btn-secondary"
                                @click.prevent="clearSearch"
                            >
                                Clear
                            </button>
                            <button
                                class="btn btn-success scan-btn"
                                @click="toggleScanner"
                            >
                                <i class="fa fa-qrcode" /> Scan
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <p v-if="loaded && !items.length">
                    No fire extinguishers found
                </p>
                <div
                    class="search-results"
                    v-if="loaded && items.length"
                >
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Code</th>
                                <th>Type / Size</th>
                                <th>Customer/Site</th>
                                <th>Last Serviced</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                class="item"
                                v-for="item in items"
                                :key="item.id"
                            >
                                <td>{{ item.code }}</td>
                                <td>{{ item.type }} / {{ item.size }}</td>
                                <td>{{ siteName(item) }}</td>
                                <td>{{ item.last_service_at | date }}</td>
                                <td class="text-right">
                                    <router-link :to="editLink(item)">
                                        View
                                    </router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <scanner
            :show="showScanner"
            @cancel="closeScanner"
            class="scanner-container"
        />
    </div>
</template>
<script>
import Scanner from './ScannerComponent';
import FEService from '../../services/FireExtinguishersService';
import SiteSearch from '../SiteSearchComponent';
export default {
    components: {
        Scanner,
        SiteSearch,
    },
    data () {
        return {
            showScanner: false,
            keyword: '',
            code: '',
            items: [],
            loaded: false,
            site: null,
        };
    },

    computed: {
        isEngineer() {
            return this.$route.path.includes('engineer');
        }
    },

    mounted () {
        this.search();
        this.$router.beforeEach((to, from, next) => {
            if (this.showScanner) {
                this.showScanner = false;
                next(false);
                return;
            }
            next();
        });
    },

    methods: {
        search () {
            FEService.index({
                search: this.keyword,
                code: this.code,
                site_id: this.site ? this.site.id : null,
            }).then(res => {
                this.items = res.data.data;
                this.loaded = true;
                if (this.code && this.items.length === 1) {
                    this.$router.push({name: 'engineer.fe.edit', params: {id: this.items[0].id}});
                }
            })
        },
        clearSearch () {
            this.keyword = null,
            this.code = null,
            this.search();
        },
        toggleScanner () {
            this.showScanner = !this.showScanner;
        },
        scannerRead (code) {
            this.keyword = null;
            this.code = code;
            window.setTimeout(() => {
                this.closeScanner();
            }, 1500)
            this.search();
        },
        siteName (fe) {
            var name = [];
            if (fe.site) {
                if (fe.site.customer) {
                    name.push(fe.site.customer.company_name);
                }
                name.push(fe.site.name);
            }

            return name.join(' - ');
        },
        closeScanner () {
            this.showScanner = false;
        },
        editLink (fe) {
            return {name: (this.isEngineer ? 'engineer' : 'office') + '.fe.edit', params: {id: fe.id}};
        },
        siteChanged(site) {
            this.site = null;
            if (site) {
                this.site = site;
            }
            this.search();
        }
    }
}
</script>
<style lang="scss" scoped>
    .search-form {
        .row {
            padding: 0 15px;
        }
        .col {
            padding: 1px;
        }
    }
    .scanner-container {
        transition: top ease .5s;
        top: 100vh;
    }
    .slide-enter-to {
        top: 0;
    }
    .slide-enter, .slide-leave-to {
        top: 100vh;
    }
    .btn-col {
        display: flex;
    }
    .scan-btn {
        margin-left: auto;
    }
    .table {
        background: white;
    }

    @media (max-width: 475px) {
        .search-form {
            .col {
                min-width: 100%;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/fireExtinguishers/IndexComponent.vue